import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  statusChip: {
    fontWeight: 500,
  },
  clickableRow: {
    cursor: 'pointer',
  },
  action: {
    padding: theme.spacing(1),
  },
}))

export default styles
